<div class="headerText">Accounts Receivable</div>
<br/>
As Of:
<p-datepicker [(ngModel)]="advancedFilters.asOfDate" [showIcon]="true" (ngModelChange)="dateChanged()" [disabled]="isLoading"></p-datepicker>
<br/><br/>
<p-table showGridlines stripedRows responsiveLayout="stack"
  #table
  class="no-pad-table-header"
  [columns]="cols"
  [value]="allWorkOrders"
  [paginator]="true"
  [rows]="rows"
  [lazy]="false"
  [loading]="isLoading"
  [dataKey]="expandField"
>
  <ng-template pTemplate="caption">
    <div class="ui-helper-clearfix">
      <p-button type="button" iconPos="left" label="Export" (click)="exportToCSV()" [disabled]="isLoading"></p-button>
    </div>
  </ng-template>
  <br/>
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th [style.width]="col.width">
          <span>{{col.header}}</span>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
    @if (rowGroupMetadata[rowData[expandField]].index === rowIndex) {
      <tr class="ui-widget-header">
        <td>
          <a href="#" [pRowToggler]="rowData">
            <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            <span>{{rowData[expandField]}}</span>
          </a>
        </td>
        <td [pRowToggler]="rowData">
          <span class="p-column-title">{{columns[1].header}}</span>
          <span>{{rowData.fullName}}</span>
        </td>
        <td [pRowToggler]="rowData"><span class="p-column-title">{{columns[2].header}}</span>{{rowData.serviceType}}</td>
        <td [pRowToggler]="rowData" class="fine-print">Expand to see details</td>
        <td [pRowToggler]="rowData" class="fine-print">Expand to see details</td>
        <td [pRowToggler]="rowData" class="fine-print">Expand to see details</td>
        <td [pRowToggler]="rowData">
          <span class="p-column-title">Total</span>
          <span>{{rowGroupMetadata[rowData[expandField]].amount | currency: 'USD'}}</span>
        </td>
        <td [pRowToggler]="rowData">
          <span class="p-column-title">Taxes</span>
          <span>{{rowGroupMetadata[rowData[expandField]].tax | currency: 'USD'}}</span>
        </td>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="expandedrow" let-workOrder let-columns="columns" let-rowIndex="rowIndex">
    <tr>
      <td>
        <span class="p-column-title">{{columns[0].header}}</span>
        <span class="regular-link" (click)="navigateToWorkOrder(workOrder)">
          {{workOrder.number}}
        </span>
      </td>
      <td>
        <span class="p-column-title">{{columns[1].header}}</span>
        <span class="regular-link" (click)="navigateToCustomer(workOrder)">{{workOrder.fullName}}</span>
      </td>
      <td><span class="p-column-title">{{columns[2].header}}</span>{{workOrder.serviceType}}</td>
      <td><span class="p-column-title">{{columns[3].header}}</span>{{workOrder.dateCompleted | date: 'shortDate'}}</td>
      <td><span class="p-column-title">{{columns[4].header}}</span>{{workOrder.paidDate | date: 'shortDate'}}</td>
      <td><span class="p-column-title">{{columns[5].header}}</span>{{workOrder.paymentStatus}}</td>
      <td><span class="p-column-title">{{columns[6].header}}</span>{{workOrder.amountDue | currency: 'USD'}}</td>      
      <td><span class="p-column-title">{{columns[7].header}}</span>{{workOrder.tax | currency: 'USD'}}</td>

    </tr>
  </ng-template>
  <ng-template pTemplate="summary" style="text-align: right;">
    @if (!isLoading) {
      <span>Total: {{total | currency: 'USD'}}</span>
    }
  </ng-template>
</p-table>
